import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TransactionType } from '@fitness-force/enum';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'transaction-type',
  templateUrl: './transaction-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class TransactionTypeComponent {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);

  getMode(value: number) {
    if (!value || value == 0) return '-';
    else if (Object.keys(value).length == 0) {
      return '-';
    } else {
      return TransactionType[value];
    }
  }
}
